import React from "react";
import { useLocation, Link } from "react-router-dom";
import "../css/paysuccess.css";
import Header from "./Header";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const PaySuccess = () => {
  const location = useLocation();
  const { orderNumber } = location.state || { orderNumber: "ORD-UNKNOWN" };

  return (
    <>
      <Header />
      <div className="successDiv">
        <div className="success-container">
          <div className="modal-content">
            <div className="checkmark-circle">
              <FontAwesomeIcon icon={faCheck} />
              <div className="checkmark"></div>
            </div>
            <h2>Payment Successful!</h2>
            <p className="success-message">Thank you for your purchase. We are reviewing your order and will process it shortly.</p>
            
            <div className="order-details-box">
              <span className="order-label">Order Number:</span>
              <span className="order-number">{orderNumber}</span>
            </div>

            <div className="success-actions">
              <Link to="/shop" className="btn-continue-shopping">
                Continue Shopping
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaySuccess;
